import { render, staticRenderFns } from "./HammerVanilla.vue?vue&type=template&id=5673572c&"
import script from "./HammerVanilla.vue?vue&type=script&lang=js&"
export * from "./HammerVanilla.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports